/**
 * GroupDropdownSearch
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';
import isEqual from 'lodash.isequal';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Workspaces
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    clearPageOnChange: boolean;
    updateQueryString: Function;
    groups?: string | string[];
    options: {
        key: number,
        text: string,
        value: number
    }[];
    multiple: boolean;
}

export class GroupDropdownSearch extends React.Component<Props> {
    componentDidUpdate(prevProps: Props) {
        const { options, groups } = this.props;
        const value = groups;

        if (!isEqual(prevProps.options, options)) {
            if (Array.isArray(value)) {
                this.props.updateQueryString({
                    entities: value.filter(id =>
                        options.some(option => option.value === id)
                    )
                });
            } else if (
                value &&
                !options.some(option => option.value === value)
            ) {
                this.props.updateQueryString({
                    entities: undefined
                });
            }
        }
    }

    handleChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { value: number }
    ) => {
        const { clearPageOnChange } = this.props;
        this.props.updateQueryString({
            ...(clearPageOnChange ? { page: undefined } : {}),
            groups: data.value,
            selectedEvent: undefined
        });
    };

    render() {
        const { groups, options, multiple } = this.props;
        return (
            <Dropdown
                placeholder="All Groups"
                search
                selection
                value={groups || null}
                clearable
                selectOnBlur={false}
                options={options}
                onChange={this.handleChange}
                lazyLoad
                multiple={multiple}
                closeOnChange
                fluid
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    groups: makeSelectQueryStringValue('groups'),
    options: selectOptions
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(GroupDropdownSearch);
